import { createStyles, Link, makeStyles, Menu, MenuItem } from '@material-ui/core';
import React, { useContext } from 'react';
import { ServerPublicMetaContext, colors } from '@terragotech/gen5-shared-components';
import TGLoginButton, { TGLoginButtonType } from './TGLoginButton';
import { MOBILE_BREAKPOINT } from '../../utils/utilityHelper';

interface SamlProvidersType {
  label: string;
  providerName: string;
}

interface LoginButtonViewProps {
  samlProviders: SamlProvidersType[];
  selectEmailLogin: () => void;
  showLogin: 'native' | 'saml' | 'both';
}

const LoginButtonView: React.FC<LoginButtonViewProps> = (props: LoginButtonViewProps) => {
  const classes = useStyles();
  const { samlProviders } = props;
  const { clientId, redirectUrl, authServerDomain } = useContext(ServerPublicMetaContext);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleAnchorOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAnchorClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.buttonContainer}>
      {!!samlProviders && samlProviders.length === 1 && (
        <TGLoginButton type={TGLoginButtonType.secondary} onClick={handleAnchorOpen}>
          <Link
            href={`https://${authServerDomain}/oauth2/authorize?client_id=${clientId}&response_type=code&scope=email+openid&redirect_uri=${redirectUrl}&identity_provider=${samlProviders[0].providerName}`}
            className={classes.samlLoginText}>
            <> {`Login with ${samlProviders[0].providerName}`}</>
          </Link>
        </TGLoginButton>
      )}
      {!!samlProviders && samlProviders.length > 1 && (
        <TGLoginButton
          type={TGLoginButtonType.secondary}
          onClick={handleAnchorOpen}
          aria-controls="saml-menu"
          aria-haspopup="true">
          <>
            {'Login with organization'}
            <Menu id="saml-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleAnchorClose}>
              {samlProviders &&
                samlProviders.map(({ label, providerName }: { label: string; providerName: string }) => (
                  <MenuItem onClick={handleAnchorClose} key={label}>
                    <Link
                      href={`https://${authServerDomain}/oauth2/authorize?client_id=${clientId}&response_type=code&scope=email+openid&redirect_uri=${redirectUrl}&identity_provider=${providerName}`}
                      className={classes.menuText}>
                      {label}
                    </Link>
                  </MenuItem>
                ))}
            </Menu>
          </>
        </TGLoginButton>
      )}
    </div>
  );
};

const useStyles = makeStyles(theme =>
  createStyles({
    buttonContainer: {
      display: 'inline-flex',
      flexDirection: 'column',
      marginTop: 30,
      [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
        marginTop: 25,
      },
    },
    dividerText: {
      color: colors.black,
      marginTop: 10,
      marginBottom: 7,
      alignSelf: 'center',
    },
    menuText: {
      color: colors.black,
    },
    samlLoginText: {
      textTransform: 'capitalize',
      '&.MuiLink-underlineHover:hover': {
        textDecoration: 'none',
      },
    },
  })
);

export default LoginButtonView;
